import React, { FunctionComponent } from 'react';
import { hooks, Grid } from '@bitrise/bitkit';
import AttributeRatio from '../../AttributeRatio/AttributeRatio';

const { useMediaQuery } = hooks;

const CrashDistribution: FunctionComponent = () => {
  const matchQuery = useMediaQuery(['700px']);

  return (
    <Grid
      gap="x6"
      margin="x6"
      repeat={
        matchQuery({
          '700px': 3,
        }) || 1
      }
      repeatWidth="1fr"
    >
      <AttributeRatio
        attribute="app.version"
        values={[
          { name: '2.6.30', percent: 0.7 },
          { name: '2.6.31', percent: 0.2 },
          { name: '2.6.33', percent: 0.1 },
        ]}
      />

      <AttributeRatio
        attribute="os.version"
        values={[
          { name: '10.0', percent: 0.5 },
          { name: '10.1', percent: 0.2 },
          { name: '10.2', percent: 0.1 },
          { name: '10.3', percent: 0.1 },
          { name: '11.0', percent: 0.05 },
          { name: '11.1', percent: 0.05 },
        ]}
      />

      <AttributeRatio
        attribute="device.network"
        values={[
          { name: '3G', percent: 0.4 },
          { name: '4G', percent: 0.3 },
          { name: '5G', percent: 0.2 },
          { name: 'EDGE', percent: 0.05 },
          { name: 'EHRPD', percent: 0.025 },
          { name: 'EVDO_A', percent: 0.025 },
        ]}
      />

      <AttributeRatio
        attribute="device.country"
        values={[
          { name: 'Canada', percent: 0.3 },
          { name: 'Iraq', percent: 0.2 },
          { name: 'Japan', percent: 0.2 },
          { name: 'Tanzania', percent: 0.1 },
          { name: 'United Kingdom', percent: 0.1 },
          { name: 'United States', percent: 0.1 },
        ]}
      />

      <AttributeRatio
        attribute="device.carrier"
        values={[
          { name: 'BT mobile', percent: 0.9 },
          { name: 'EE', percent: 0.02 },
          { name: 'GiffGaff', percent: 0.02 },
          { name: 'Sky mobile', percent: 0.02 },
          { name: 'Tesco mobile', percent: 0.01 },
          { name: 'Three', percent: 0.01 },
        ]}
      />

      <AttributeRatio
        attribute="device.type"
        values={[
          { name: 'iPad (5th generation)', percent: 0.4 },
          { name: 'iPad (6th generation)', percent: 0.3 },
          { name: 'iPad2', percent: 0.1 },
          { name: 'iPad3', percent: 0.1 },
          { name: 'iPad4', percent: 0.05 },
          { name: 'iPhone X', percent: 0.05 },
        ]}
      />
    </Grid>
  );
};

export default CrashDistribution;
